import type { ToolsStore } from './interfaces'

export const getters = {
  isClarityReady: (state: ToolsStore): ToolsStore['clarityReady'] => state.clarityReady,
  isMetaPixelReady: (state: ToolsStore): ToolsStore['metaPixelReady'] => state.metaPixelReady,
}
